import { ReactNode, useState } from "react"
import DashboardTopbar from "@/components/DashboardTopbar"
import AdminNavigation from "@/components/admin/AdminNavigation"
import Button from "@/components/Button"
import { Modals, useModals } from "@/hooks/useModals"
import PromotionModal from "@/modals/PromotionModal"
import AppLayout from "@/layouts/AppLayout"
import { usePage } from "@inertiajs/react"
import { AdminPromotionsProps } from "@/types/types"
import { AdminPromotion } from "@/types/serializers"
import PromotionItem from "@/components/PromotionItem"

const AdminPromotionsPage = () => {
  const { promotions } = usePage<AdminPromotionsProps>().props

  const [selectedPromotion, setSelectedPromotion] =
    useState<AdminPromotion | null>(null)

  const { openModal } = useModals()

  return (
    <>
      <DashboardTopbar title="Admin" />
      <AdminNavigation />

      <div className="padding mx-auto w-full max-w-xl space-y-8 py-6">
        <div className="flex items-center justify-between">
          <h2 className="text-lg font-semibold text-gray-900">Promotions</h2>

          <Button size="sm" onClick={() => openModal(Modals.Promotion)}>
            Create promotion
          </Button>
        </div>

        {promotions?.length > 0 ? (
          <ul className="space-y-3">
            {promotions.map((promotion) => (
              <PromotionItem
                key={promotion.id}
                promotion={promotion}
                setSelectedPromotion={setSelectedPromotion}
              />
            ))}
          </ul>
        ) : null}

        <PromotionModal
          selectedPromotion={selectedPromotion}
          setSelectedPromotion={setSelectedPromotion}
        />
      </div>
    </>
  )
}

AdminPromotionsPage.layout = (page: ReactNode) => <AppLayout>{page}</AppLayout>

export default AdminPromotionsPage
